import React from "react";
import DeviceShowcase from "../DeviceShowcase";

export default function WarehouseMockup() {
  const desktopUI = (
    <div className="w-full h-full flex flex-col text-sm bg-white">
      <div className="bg-slate-50 border-b border-slate-200 p-2 md:p-3 flex items-center justify-between">
        <span className="font-semibold text-slate-700 text-xs md:text-sm">
          Quản lý Tồn kho Vật tư Bao bì
        </span>
        <span className="px-2 py-1 bg-slate-200 text-slate-700 rounded text-[10px] md:text-xs font-medium">
          Kho Nguyên Liệu (Kho 1)
        </span>
      </div>
      <div className="p-3 md:p-4 flex-1 flex flex-col gap-4 overflow-auto">
        <div className="grid grid-cols-3 gap-3">
          <div className="bg-blue-50 text-blue-900 p-3 rounded border border-blue-100">
            <div className="text-[10px] md:text-xs text-blue-700/70 mb-1">
              Tổng Cuộn Giấy
            </div>
            <div className="font-bold text-sm md:text-lg">145 Cuộn</div>
          </div>
          <div className="bg-emerald-50 text-emerald-900 p-3 rounded border border-emerald-100">
            <div className="text-[10px] md:text-xs text-emerald-700/70 mb-1">
              Tổng Giấy Tờ
            </div>
            <div className="font-bold text-sm md:text-lg">2.5 Triệu Tờ</div>
          </div>
          <div className="bg-red-50 text-red-900 p-3 rounded border border-red-100 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-8 h-8 bg-red-500 rounded-bl-full animate-pulse"></div>
            <div className="text-[10px] md:text-xs text-red-700/70 mb-1">
              Cảnh báo hết vật tư
            </div>
            <div className="font-bold text-sm md:text-lg">3 Mã</div>
          </div>
        </div>

        <div className="space-y-2">
          <div className="border border-slate-200 rounded-md overflow-hidden shadow-sm">
            <table className="w-full text-left">
              <thead className="bg-slate-50 border-b border-slate-200 text-[10px] md:text-xs text-slate-500">
                <tr>
                  <th className="p-1.5 md:p-2 font-medium">Mã / Tên Vật Tư</th>
                  <th className="p-1.5 md:p-2 font-medium">Quy cách</th>
                  <th className="p-1.5 md:p-2 font-medium">Vị trí Kệ</th>
                  <th className="p-1.5 md:p-2 font-medium text-right">
                    Tồn kho
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 text-[10px] md:text-xs">
                <tr>
                  <td className="p-1.5 md:p-2 font-medium text-slate-800">
                    Giấy Ivory 350gsm
                  </td>
                  <td className="p-1.5 md:p-2">Tờ 79x109</td>
                  <td className="p-1.5 md:p-2">
                    <span className="px-1.5 py-0.5 bg-slate-100 border border-slate-200 rounded text-[9px] font-mono">
                      K-A-01
                    </span>
                  </td>
                  <td className="p-1.5 md:p-2 text-right">
                    15 Pallet{" "}
                    <span className="text-slate-400 text-[9px] block">
                      (150,000 tờ)
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="p-1.5 md:p-2 font-medium text-slate-800">
                    Giấy Couche 150gsm
                  </td>
                  <td className="p-1.5 md:p-2">Cuộn 65cm</td>
                  <td className="p-1.5 md:p-2">
                    <span className="px-1.5 py-0.5 bg-slate-100 border border-slate-200 rounded text-[9px] font-mono">
                      K-B-05
                    </span>
                  </td>
                  <td className="p-1.5 md:p-2 text-right">
                    12 Cuộn{" "}
                    <span className="text-slate-400 text-[9px] block">
                      (12.5 Tấn)
                    </span>
                  </td>
                </tr>
                <tr className="bg-red-50/50">
                  <td className="p-1.5 md:p-2 font-medium text-red-800 flex items-center gap-1">
                    Mực Offset Magenta{" "}
                    <span className="w-1.5 h-1.5 rounded-full bg-red-500"></span>
                  </td>
                  <td className="p-1.5 md:p-2 text-red-700">Lon 2.5kg</td>
                  <td className="p-1.5 md:p-2">
                    <span className="px-1.5 py-0.5 bg-red-100 border border-red-200 text-red-700 rounded text-[9px] font-mono">
                      M-A-02
                    </span>
                  </td>
                  <td className="p-1.5 md:p-2 text-right font-bold text-red-600">
                    2 Lon{" "}
                    <span className="text-red-400 text-[9px] block">
                      (Min: 10 Lon)
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );

  const mobileUI = (
    <div className="w-full h-full flex flex-col bg-slate-800 text-slate-200">
      <div className="bg-slate-900 border-b border-slate-700 p-3 flex items-center gap-2 z-10 sticky top-0 shadow-md">
        <div className="w-6 h-6 rounded-md bg-emerald-500/20 text-emerald-400 flex items-center justify-center">
          📷
        </div>
        <span className="text-xs font-semibold text-white">
          Scanner Nhập/Xuất
        </span>
      </div>

      <div className="flex-1 p-3 flex flex-col relative">
        {/* Scanner overlay */}
        <div className="w-full aspect-square border-2 border-emerald-500/50 rounded-xl relative overflow-hidden mb-4 flex items-center justify-center bg-slate-950">
          <div className="absolute top-0 left-0 w-full h-1 bg-emerald-400 shadow-[0_0_15px_#34d399] animate-[scan_2s_ease-in-out_infinite]"></div>
          <div className="w-24 h-24 border-4 border-dashed border-slate-600 opacity-50"></div>
        </div>

        <div className="bg-slate-900 p-3 rounded-xl border border-emerald-500/30 shadow-[0_0_10px_rgba(16,185,129,0.1)]">
          <div className="flex items-center gap-2 mb-2 pb-2 border-b border-slate-700">
            <div className="w-4 h-4 rounded-full bg-emerald-500 flex items-center justify-center text-[10px] text-slate-900">
              ✓
            </div>
            <span className="text-xs font-bold text-emerald-400">
              Đã nhận diện Barcode
            </span>
          </div>
          <div className="space-y-1">
            <div className="flex justify-between text-[10px]">
              <span className="text-slate-400">Mã Lô/Pallet</span>
              <span className="font-mono text-white">LOT-2605-A15</span>
            </div>
            <div className="flex justify-between text-[10px]">
              <span className="text-slate-400">Vật tư</span>
              <span className="font-bold text-white">Giấy Ivory 350gsm</span>
            </div>
            <div className="flex justify-between text-[10px]">
              <span className="text-slate-400">Số lượng</span>
              <span className="text-white">10,000 Tờ</span>
            </div>
          </div>
        </div>

        <div className="mt-auto pt-3">
          <button className="w-full bg-emerald-600 text-white py-2.5 rounded-lg text-xs font-bold shadow-md shadow-emerald-900 transition-colors hover:bg-emerald-500">
            Xác nhận Xuất Kho
          </button>
        </div>
      </div>
    </div>
  );

  return <DeviceShowcase desktopUI={desktopUI} mobileUI={mobileUI} />;
}
